/**
 * Ploufe — "Laat je eigen kleed maken". Het formulier doet een normale,
 * volledige POST naar /cart/add (bewust geen AJAX — zie de toelichting in
 * sections/plf-eigen-ontwerp.liquid voor waarom dat nodig is voor de
 * bestandsupload) met een eigen return_to. Na de redirect terug op deze
 * pagina toont dit script de bedanktmelding i.p.v. het formulier, en haalt
 * het het €0-aanvraagproduct meteen weer uit de winkelwagen, zodat de klant
 * nooit per ongeluk afrekent met dat regel erin.
 *
 * Komt de bezoeker uit de stijlwijzer (?bron=stijlwijzer, assets/
 * lan-quiz-logic.js maatwerkUrl), dan staan de antwoorden al ingevuld:
 * afmeting ("Groter dan …" bij maat=groter), kleur, en in de toelichting
 * stijl, vorm, ruimte en het gekozen kleed. Alleen lege velden worden
 * gevuld; het gekozen kleed gaat ook mee als eigen regel (Gekozen kleed).
 *
 * Komt de bezoeker van "Eigen maat" op een productpagina (?bron=maat, assets/
 * lan-maatwerk.js: maat boven € 5.990 of buiten de maatgrenzen), dan staan
 * de afmeting en het kleed al ingevuld.
 */
(function () {
  'use strict';

  function fill(form, name, value) {
    var field = form.querySelector('[name="properties[' + name + ']"]');
    if (field && value && !field.value) field.value = value;
  }

  function addChosenRug(form, params, kleed) {
    if (kleed && !form.querySelector('[name="properties[Gekozen kleed]"]')) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Gekozen kleed]';
      hidden.value = kleed + (params.get('kleed_handle') ? ' (/products/' + params.get('kleed_handle') + ')' : '');
      form.appendChild(hidden);
    }
  }

  function addNote(form, text) {
    var note = document.createElement('p');
    note.className = 'plf-eigen__prefill-note';
    note.textContent = text;
    form.insertBefore(note, form.firstChild);
  }

  function prefillFromSize(root, params) {
    var form = root.querySelector('[data-plf-eigen-form]');
    if (!form) return;
    var kleed = params.get('kleed') || '';
    var afmeting = params.get('afmeting') || '';
    fill(form, 'Gewenste afmeting', afmeting);
    if (kleed) fill(form, 'Toelichting', 'Ik wil graag ' + kleed + (afmeting ? ' in ' + afmeting : '') + '.');
    addChosenRug(form, params, kleed);
    addNote(form, 'Je ontwerp en maat staan al ingevuld. Pas ze gerust aan.');
  }

  function prefillFromQuiz(root, params) {
    if (params.get('bron') === 'maat') {
      prefillFromSize(root, params);
      return;
    }
    if (params.get('bron') !== 'stijlwijzer') return;
    var form = root.querySelector('[data-plf-eigen-form]');
    if (!form) return;
    var vorm = params.get('vorm') || '';
    var stijl = params.get('stijl') || '';
    var ruimte = params.get('ruimte') || '';
    var kleed = params.get('kleed') || '';

    if (params.get('maat') === 'groter') {
      var size = vorm === 'Rond' ? 'Ø 300 cm' : vorm ? '250 x 350 cm' : '250 x 350 cm of Ø 300 cm';
      fill(form, 'Gewenste afmeting', 'Groter dan ' + size);
    }
    fill(form, 'Gewenste kleuren', params.get('kleur') || '');

    var parts = [];
    if (stijl) parts.push('stijl ' + stijl.toLowerCase());
    if (vorm) parts.push('vorm ' + vorm.toLowerCase());
    if (ruimte) parts.push('voor de ' + ruimte);
    var text = parts.length ? 'Uit de stijlwijzer: ' + parts.join(', ') + '.' : '';
    if (kleed) text += (text ? ' ' : '') + 'Ik wil graag ' + kleed + ' in mijn maat.';
    fill(form, 'Toelichting', text);

    addChosenRug(form, params, kleed);
    addNote(form, 'Je antwoorden uit de stijlwijzer staan al ingevuld. Pas ze gerust aan.');
  }

  function initEigenOntwerp(root) {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('aanvraag')) {
      prefillFromQuiz(root, params);
      return;
    }

    var form = root.querySelector('[data-plf-eigen-form]');
    var success = root.querySelector('[data-plf-eigen-success]');
    if (form) form.hidden = true;
    if (success) {
      success.hidden = false;
      success.focus();
    }

    var removeUrl = root.getAttribute('data-remove-url');
    var variantId = root.getAttribute('data-variant-id');
    if (removeUrl && variantId) {
      fetch(removeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      }).catch(function () {
        // Niet kritiek als dit faalt — het is alleen opruimen, de aanvraag zelf staat al in Admin.
      });
    }

    // Zorgt dat "aanvraag=1" niet blijft hangen als de bezoeker ververst of deelt.
    if (window.history && window.history.replaceState) {
      params.delete('aanvraag');
      var newSearch = params.toString();
      var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
      window.history.replaceState(null, '', newUrl);
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-plf-eigen-ontwerp]'), initEigenOntwerp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
